import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Menu, Truck, X } from "lucide-react";

const sections = [
  ["services", "Our parts"],
  ["network", "Our network"],
  ["process", "The process"],
];

export const Header = ({ onSection, onQuote }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const close = () => setMobileOpen(false);
  return (
    <>
      <div className="announcement" data-testid="shipping-announcement"><Truck size={14} /> Nationwide delivery. One parts desk. Every state.</div>
      <header className="nav-wrap" data-testid="site-header">
        <Link className="brand" to="/" onClick={close} data-testid="brand-link"><span>DECODE</span><small>AUTO DEALS</small></Link>
        <nav className={mobileOpen ? "nav-links open" : "nav-links"} data-testid="desktop-navigation">
          {sections.map(([id, label]) => onSection ? (
            <button key={id} onClick={() => { close(); onSection(id); }} data-testid={`nav-${id}-button`}>{label}</button>
          ) : (
            <Link key={id} to={`/#${id}`} onClick={close} data-testid={`nav-${id}-link`}>{label}</Link>
          ))}
          {onQuote ? (
            <button className="nav-cta" onClick={() => { close(); onQuote(); }} data-testid="nav-quote-button">Request a quote <ArrowRight size={15} /></button>
          ) : (
            <Link className="nav-cta" to="/?quote=1" onClick={close} data-testid="nav-quote-link">Request a quote <ArrowRight size={15} /></Link>
          )}
        </nav>
        <button className="menu-button" onClick={() => setMobileOpen(!mobileOpen)} data-testid="mobile-menu-button" aria-label="Toggle menu">{mobileOpen ? <X /> : <Menu />}</button>
      </header>
    </>
  );
};

export const Footer = () => (
  <footer className="footer" data-testid="site-footer">
    <Link className="brand" to="/" data-testid="footer-brand-link"><span>DECODE</span><small>AUTO DEALS</small></Link>
    <nav className="footer-links" data-testid="footer-policy-links">
      <Link to="/about" data-testid="footer-about-link">About</Link>
      <Link to="/warranty-policy" data-testid="footer-warranty-link">Warranty</Link>
      <Link to="/returns-refunds" data-testid="footer-returns-link">Returns & refunds</Link>
      <Link to="/privacy-policy" data-testid="footer-privacy-link">Privacy</Link>
      <Link to="/terms-and-conditions" data-testid="footer-terms-link">Terms</Link>
    </nav>
    <p>Used parts. Higher standards.</p>
    <span>© 2026 DECODEAUTODEALS</span>
  </footer>
);
